import { api } from "./api";

/** Registro del service worker (avisos y uso sin conexión). */
export const registerSW = () => {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => { navigator.serviceWorker.register("/service-worker.js", { scope: "/" }).catch(() => {}); });
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const toKey = (v) => {
  const b = (v + "=".repeat((4 - (v.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(b), (c) => c.charCodeAt(0));
};

/** Pide permiso (desde un toque del usuario) y suscribe este celular. Con code+t suma los avisos de ese pasaje; con route ("Origen|Destino") solo las promos de ese tramo. */
export const enablePush = async ({ code, t, route } = {}) => {
  if (!pushSupported()) throw new Error(isIOS() ? "En iPhone primero instalá la app (Compartir → Agregar a inicio) y abrila desde el ícono." : "Este navegador no permite notificaciones.");
  const reg = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("No diste permiso para notificaciones. Podés activarlo en los ajustes del celular.");
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) });
  }
  const j = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys, promos: true, code: code || null, t: t || null, route: route || null });
  if (code) localStorage.setItem(`sg_push_${code}`, "1");
  if (!route) localStorage.setItem("sg_push", "1");
  return true;
};

export const pushEnabled = (code) => typeof Notification !== "undefined" && Notification.permission === "granted" && localStorage.getItem(code ? `sg_push_${code}` : "sg_push") === "1";

/* Pasajes guardados en el celular para verlos sin internet. */
const KEY = "sg_tickets";
export const savedTickets = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
export const saveTicket = (path, b) => {
  try {
    const all = savedTickets();
    all[path] = { b, saved_at: new Date().toISOString() };
    const keep = Object.entries(all).sort((x, y) => (y[1].b?.date || "").localeCompare(x[1].b?.date || "")).slice(0, 10);
    localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(keep)));
  } catch { /* almacenamiento lleno o bloqueado */ }
};
